import { render } from "./FaqsPage.vue?vue&type=template&id=14b1b78c&scoped=true"
import script from "./FaqsPage.vue?vue&type=script&lang=js"
export * from "./FaqsPage.vue?vue&type=script&lang=js"

import "./FaqsPage.vue?vue&type=style&index=0&id=14b1b78c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b1b78c"]])

export default __exports__